// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"71245d05","921":"70b75310"}[chunkId] + ".chunk.css";
};